import { SVGProps } from 'react';

const SendHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 12a.5.5 0 0 1-.286.452l-18 8.5a.497.497 0 0 1-.682-.627l2.842-7.627a2 2 0 0 0 0-1.396L3.031 3.675a.498.498 0 0 1 .683-.627l18 8.5A.5.5 0 0 1 22 12m0 0H6"
    />
  </svg>
);
export default SendHorizontal;
